import React from 'react';

import { ViewType, useViewType } from '@eika/hooks';
import { IconTypes } from '@eika/icon';
import { IconLink } from '@eika/link';
import { ListPanel, ListPanelWrapper } from '@eika/link-panel';

import { TotalAccountBalance } from '..';
import { AccountList } from '../../../../components/AccountList';
import { useConfig } from '../../../../defaultConfig';
import { Account } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';

type AccountsOverviewContentProps = {
    accounts: Account[];
    header?: string;
};

export const AccountsOverviewContent = ({ accounts, header }: AccountsOverviewContentProps) => {
    const { accountLink, editAccountsLink, createAccountsLink, featureToggles } = useConfig();
    const translated = useTranslation();

    const viewType = useViewType();

    const hasAccount = !!accounts && accounts.length > 0;

    return (
        <ListPanelWrapper
            className="account-overview"
            data-testid="account-overview-list"
            titleContent={
                <div className="account-list-title">
                    <div className="account-overview__header-container">
                        <h2 className="account-overview__header typography-subtitle-bold">{header}</h2>
                        {editAccountsLink && hasAccount && (
                            <IconLink
                                label={translated.editAccounts.view}
                                icon={IconTypes.PENN_24}
                                href={editAccountsLink.url}
                                className="account-overview__button-icon"
                            />
                        )}
                    </div>
                </div>
            }
            contentWrapperAs="ol"
            footerContent={hasAccount && <TotalAccountBalance accounts={accounts} />}
            footerClassName="account-overview__footer"
        >
            <AccountList detailsLink={accountLink?.url} accounts={accounts ?? []} />
            {hasAccount &&
                createAccountsLink &&
                !featureToggles.disableAccountCreation &&
                viewType === ViewType.mobile && (
                    <ListPanel
                        className="create-account-link"
                        url={createAccountsLink.url}
                        title={createAccountsLink.text ?? translated.accountsList.createAccount}
                        textTwo={translated.accountsList.infoOnAccounts}
                        icon={IconTypes.PLUSS_DYN}
                        as="li"
                        data-testid="start-create-account-mobile"
                        backgroundColor="light"
                    />
                )}
        </ListPanelWrapper>
    );
};
